import type { Preferences } from "./preferences";

export class LocalSound {
  private context: AudioContext | null = null;

  constructor(private preferences: Preferences) {}

  setPreferences(preferences: Preferences): void { this.preferences = preferences; }

  play(kind: "click" | "ready" | "checkpoint" | "finish"): void {
    if (!this.preferences.soundEnabled) return;
    const AudioContextClass = window.AudioContext ?? (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextClass) return;
    this.context ??= new AudioContextClass();
    if (this.context.state === "suspended") void this.context.resume();

    const context = this.context;
    const now = context.currentTime;
    const notes = kind === "finish" ? [660, 880, 1100] : kind === "checkpoint" ? [510, 710] : kind === "ready" ? [620, 760] : [430];
    notes.forEach((frequency, index) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = "triangle";
      oscillator.frequency.setValueAtTime(frequency, now + index * 0.055);
      gain.gain.setValueAtTime(0.0001, now + index * 0.055);
      gain.gain.exponentialRampToValueAtTime(0.055, now + index * 0.055 + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + index * 0.055 + 0.13);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(now + index * 0.055);
      oscillator.stop(now + index * 0.055 + 0.14);
    });
  }
}
